export const EVENT_SERVICES_CATEGORY = {
  esmd10000: 'esmd10000',
  esmd20000: 'esmd20000',
  esmd30000: 'esmd30000',
  esmd50000: 'esmd50000',
  esmd100000: 'esmd100000',
  esmd250000: 'esmd250000',
  esmd500000: 'esmd500000',
  esmd1000000: 'esmd1000000',
}

export const EVENT_SERVICES_KEYS = [
  EVENT_SERVICES_CATEGORY.esmd10000,
  EVENT_SERVICES_CATEGORY.esmd20000,
  EVENT_SERVICES_CATEGORY.esmd30000,
  EVENT_SERVICES_CATEGORY.esmd50000,
  EVENT_SERVICES_CATEGORY.esmd100000,
  EVENT_SERVICES_CATEGORY.esmd250000,
  EVENT_SERVICES_CATEGORY.esmd500000,
  EVENT_SERVICES_CATEGORY.esmd1000000,
]
